import { render, staticRenderFns } from "./BundleClaimModal.vue?vue&type=template&id=8d7fed62&scoped=true"
import script from "./BundleClaimModal.vue?vue&type=script&lang=js"
export * from "./BundleClaimModal.vue?vue&type=script&lang=js"
import style0 from "./BundleClaimModal.vue?vue&type=style&index=0&id=8d7fed62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7fed62",
  null
  
)

export default component.exports